export enum PaymentMethodTypesEnum {
  Bank = 'bank',
  Card = 'card',
}

const getIsPaymentMethod =
  <T extends PaymentMethodTypesEnum>(enumType: T) =>
  (paymentMethodType: PaymentMethodTypesEnum): paymentMethodType is T =>
    paymentMethodType === enumType;

export const isPaymentMethodBank = getIsPaymentMethod(
  PaymentMethodTypesEnum.Bank,
);
export const isPaymentMethodCard = getIsPaymentMethod(
  PaymentMethodTypesEnum.Card,
);
